import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 14 14"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M7 1.094a5.907 5.907 0 1 1-.002 11.814A5.907 5.907 0 0 1 7 1.094m0-.875a6.782 6.782 0 1 0 .002 13.564A6.782 6.782 0 0 0 7 .22m-.984 9.406h.328V6.344h-.328a.33.33 0 0 1-.328-.328v-.22c0-.18.147-.327.328-.327h1.312c.181 0 .328.147.328.328v3.828h.328c.181 0 .329.147.329.328v.219a.33.33 0 0 1-.329.328H6.016a.33.33 0 0 1-.328-.328v-.219c0-.181.147-.328.328-.328M7 3.063a.875.875 0 1 0 0 1.749.875.875 0 0 0 0-1.75" }, null, -1)
  ])))
}
export default { render: render }